import { render, staticRenderFns } from "./DataImageFieldCard.vue?vue&type=template&id=40ed3177&"
import script from "./DataImageFieldCard.vue?vue&type=script&lang=js&"
export * from "./DataImageFieldCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports